import { orderAcceptanceStatusTypes } from './util'

const rowStyle = record => {
  const { color } = orderAcceptanceStatusTypes[record.acceptance_status]
  return { background: color }
}

export default rowStyle
